"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { CONSENT_CHANGE_EVENT, readConsentSnapshot } from "@/lib/consent";

const VercelAnalytics = dynamic(
  () => import("@vercel/analytics/react").then((module) => module.Analytics),
  { ssr: false },
);

const VercelSpeedInsights = dynamic(
  () => import("@vercel/speed-insights/next").then((module) => module.SpeedInsights),
  { ssr: false },
);

export function ConsentAwareTelemetry() {
  const [analyticsAllowed, setAnalyticsAllowed] = useState(false);

  useEffect(() => {
    function applyConsent(snapshot = readConsentSnapshot()) {
      setAnalyticsAllowed(snapshot.analytics === true);
    }

    function handleConsentChange(event) {
      applyConsent(event.detail);
    }

    applyConsent();
    window.addEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, handleConsentChange);
  }, []);

  if (!analyticsAllowed) return null;

  return (
    <>
      <VercelSpeedInsights />
      <VercelAnalytics />
    </>
  );
}
